import React from 'react';
import { Button } from 'semantic-ui-react';
import cx from 'classnames';
import { default as Icon } from '@plone/volto/components/theme/Icon/Icon';
import { default as ConditionalLink } from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

import { defineMessages, useIntl } from 'react-intl';
import arrowRight from '../../../theme/icons/arrow-right.svg';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const messages = defineMessages({
  ButtonText: {
    id: 'Button text',
    defaultMessage: 'Button text',
  },
});

const icons = {
  'icon-right': (
    <Icon className="arrow svg-inline--fa" name={arrowRight} title="arrow" />
  ),
  'icon-down': (
    <Icon
      className="arrow svg-inline--fa rotate-90"
      name={arrowRight}
      title="arrow"
    />
  ),
  'icon-download': <FontAwesomeIcon icon={faDownload} />,
};

const View = ({ data, isEditMode, className, style }) => {
  const [hasLink, setHasLink] = React.useState(false);
  const intl = useIntl();
  React.useEffect(() => {
    if (data.href) {
      if (data.href && data.href.length > 0) {
        setHasLink(true);
      }
      if (data.href.length === 0) {
        setHasLink(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.href]);

  let link = hasLink ? (
    data.href.length > 0 && (
      <ConditionalLink
        to={data.href[0]?.['@id']}
        condition={!isEditMode}
        openLinkInNewTab={data.openLinkInNewTab}
        as="button"
      >
        <Button className={cx('', className, data.align)}>
          {data.title || intl.formatMessage(messages.ButtonText)}{' '}
          {data.icon ? (
            icons[data.icon]
          ) : (
            <Icon
              className="arrow svg-inline--fa"
              name={arrowRight}
              title="arrow"
              style={{ width: '12px', height: '12px' }}
            />
          )}
        </Button>
      </ConditionalLink>
    )
  ) : (
    <ConditionalLink
      to={data?.anchor}
      condition={!isEditMode}
      openLinkInNewTab={data.openLinkInNewTab}
      as="button"
    >
      <Button className={cx('', className, data.align)}>
        {data.title || intl.formatMessage(messages.ButtonText)}{' '}
        {data.icon ? (
          icons[data.icon]
        ) : (
          <Icon
            className="arrow svg-inline--fa rotate-90"
            name={arrowRight}
            title="arrow"
            style={{ width: '12px', height: '12px' }}
          />
        )}
      </Button>
    </ConditionalLink>
  );

  return (
    <div className={cx('block __button', className)} style={style}>
      <div className="button container">
        <div className={cx(`align ${data?.inneralign}`)}>{link}</div>
      </div>
    </div>
  );
};

export default View;
